import { forwardRef, useMemo } from 'react'

import { Badge, Tooltip } from 'slab'

interface PlanBadgeProps {
  bordered?: boolean;
  type: 'hmo' | 'ppo' | 'pos' | 'epo';
}

const EPO_INFO =
  'No referrals needed to see someone new, but only covers in-network care (except in emergencies)'
const HMO_INFO =
  "Lower costs, but you'll need referrals and must stay in-network for care"
const PPO_INFO =
  'Higher monthly cost, but more flexibility — see any provider, including out-of-network'
const POS_INFO =
  'Covers out-of-network care like a PPO, but often requires referrals like an HMO'

export const PlanBadge = forwardRef<HTMLSpanElement, PlanBadgeProps>(
  ({ bordered = false, type }, forwardedRef) => {
    const { tooltipContent } = useMemo(() => {
      let tooltipContent: string
      switch (type) {
        case 'epo':
          tooltipContent = EPO_INFO
          break
        case 'hmo':
          tooltipContent = HMO_INFO
          break
        case 'ppo':
          tooltipContent = PPO_INFO
          break
        case 'pos':
          tooltipContent = POS_INFO
          break
        default:
          tooltipContent = ''
      }

      return { tooltipContent }
    }, [type])

    return (
      <Tooltip content={tooltipContent}>
        <Badge bordered={bordered} ref={forwardedRef}>
          {type.toUpperCase()}
        </Badge>
      </Tooltip>
    )
  }
)
